import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'donottravel',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './chinaandirandonottravel.component.html',
  styleUrl: './chinaandirandonottravel.component.scss',
})
export class ChinaandirandonottravelComponent {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = '';

  ngOnInit() {
    this.titleService.setTitle(
      'China & Iran Do Not Travel Advisory | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover travel insurance update: No cover is available for China and Iran while government ‘Do Not Travel’ warnings remain in place due to COVID-19.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'China & Iran Do Not Travel Advisory | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover travel insurance update: No cover is available for China and Iran while government ‘Do Not Travel’ warnings remain in place due to COVID-19.',
    });
    this.pageTitleImg = 'assets/images/w2c/page-header/travel-in.jpg';
    this.pageHead = 'China and Iran - Do Not Travel Advisory';
  }
}
